var _defs, _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCause3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff305e;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 74,
    cy: 86,
    r: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.89,74.86h-5.89s0-10,0-10c0-3.87-3.13-7-7-7h-4v-22.86c0-2.76-2.24-5-5-5h-10c0-3.86-3.14-7-7-7h-23v-12.03c0-2.19-1.78-3.97-3.97-3.97h-14.06c-2.19,0-3.97,1.78-3.97,3.97v1.06c0,2.19,1.78,3.97,3.97,3.97h7.03c1.1,0,2,.89,2,2,0,7.35,0,32.48,0,32.48-10.11,2.16-17.61,11.44-16.96,22.32.63,10.64,9.23,19.37,19.86,20.14,12.06.88,22.22-8.27,23.03-19.94h24.08v6.3c-3.29.98-5.57,4.32-4.87,8.05.52,2.75,2.72,4.98,5.47,5.52,4.47.88,8.41-2.54,8.41-6.86,0-3.16-2.11-5.84-5-6.71v-17.43h4c1.66,0,3,1.34,3,3v10c0,2.21,1.79,4,4,4h6c1.21,0,2.18-1.08,1.97-2.34-.16-.98-1.08-1.66-2.08-1.66ZM26.5,89c-9.65,0-17.5-7.85-17.5-17.5s7.85-17.5,17.5-17.5,17.5,7.85,17.5,17.5-7.85,17.5-17.5,17.5ZM31,30v-3h23c1.65,0,3,1.35,3,3h-26ZM79,86c0,2.76-2.24,5-5,5s-5-2.24-5-5,2.24-5,5-5,5,2.24,5,5Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.5,
    cy: 71.5,
    r: 12.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause3);
export default __webpack_public_path__ + "static/media/cause_3.f77e635abc483225ae52446ed73643a6.svg";
export { ForwardRef as ReactComponent };